import { FetchConnectorListFilters } from './connectorsApi';

export * from './connectorsApi';
export * from './providerApi';
export * from './partnersConnectorsApi';

export const connectorsQueryKeys = {
    all: ['marketplace', 'connectors'] as const,
    list: (filters: FetchConnectorListFilters) => [...connectorsQueryKeys.all, { ...filters }] as const,
    item: (id: string) => [...connectorsQueryKeys.all, id] as const,
};
